import React from 'react'
import { NumberTextBox } from '../../TextBox/NumberTextBox'
import { ISchoolTabItemProps } from './SchoolTabItem.types'

const QCAASchoolResultTabItem: React.FC<ISchoolTabItemProps> = ({
  results,
  onChange,
}) => (
  <>
    <NumberTextBox
      labelText="IBD"
      value={results.ibd}
      onChange={(v) => onChange({ ibd: v })}
    />
    <NumberTextBox
      labelText="OPS"
      value={results.op}
      onChange={(v) => onChange({ op: v })}
    />
    <NumberTextBox
      labelText="% OP 1-5"
      value={results.op1To5}
      onChange={(v) => onChange({ op1To5: v })}
    />
    <NumberTextBox
      labelText="% OP 6-10"
      value={results.op6To10}
      onChange={(v) => onChange({ op6To10: v })}
    />
    <NumberTextBox
      labelText="% OP 11-15"
      value={results.op11To15}
      onChange={(v) => onChange({ op11To15: v })}
    />
    <NumberTextBox
      labelText="% OP 16-20"
      value={results.op16To20}
      onChange={(v) => onChange({ op16To20: v })}
    />
    <NumberTextBox
      labelText="% OP 21-25"
      value={results.op21To25}
      onChange={(v) => onChange({ op21To25: v })}
    />
    <NumberTextBox
      labelText="Higher than Op 5%"
      value={results.higherThanOp5Percent}
      onChange={(v) => onChange({ higherThanOp5Percent: v })}
    />
    <NumberTextBox
      labelText="Higher than Op 10%"
      value={results.higherThanOp10Percent}
      onChange={(v) => onChange({ higherThanOp10Percent: v })}
    />
    <NumberTextBox
      labelText="Higher than Op 15%"
      value={results.higherThanOp15Percent}
      onChange={(v) => onChange({ higherThanOp15Percent: v })}
    />
    <NumberTextBox
      labelText="Higher than Op 20%"
      value={results.higherThanOp20Percent}
      onChange={(v) => onChange({ higherThanOp20Percent: v })}
    />
    <NumberTextBox
      labelText="Higher than Op 25%"
      value={results.higherThanOP25Percent}
      onChange={(v) => onChange({ higherThanOP25Percent: v })}
    />
    <NumberTextBox
      labelText="QCE"
      value={results.qce}
      onChange={(v) => onChange({ qce: v })}
    />
    <NumberTextBox
      labelText="QCIA"
      value={results.qcia}
      onChange={(v) => onChange({ qcia: v })}
    />
    <NumberTextBox
      labelText="IBD"
      value={results.ibd}
      onChange={(v) => onChange({ ibd: v })}
    />
    <NumberTextBox
      labelText="SEP"
      value={results.sep}
      onChange={(v) => onChange({ sep: v })}
    />
    <NumberTextBox
      labelText="VET"
      value={results.vet}
      onChange={(v) => onChange({ vet: v })}
    />
    <NumberTextBox
      labelText="Senior Statement Only"
      value={results.seniorStatementOnly}
      onChange={(v) => onChange({ seniorStatementOnly: v })}
    />
  </>
)

export { QCAASchoolResultTabItem }
